import React, { useState } from "react";
import { BellRing, Check } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

// Opt-in "premiere starts in 1 hour" email (sent by the hourly cron in Brisbane time).
export default function PremiereReminder({ entryId, pupName }) {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (ev) => {
    ev.preventDefault(); setBusy(true);
    try { const { data } = await api.post("/redcarpet/premiere-remind", { email, entry_id: entryId }); setDone(data.message); toast.success("Reminder set 🎬"); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  if (done) return <p className="mt-4 inline-flex items-center gap-2 rounded-full bg-[#7ED957]/25 border border-[#7ED957] px-4 py-2 text-sm font-bold" data-testid="premiere-remind-done"><Check className="w-4 h-4 text-[#7ED957]" /> {done}</p>;
  return (
    <form onSubmit={submit} className="mt-4 flex flex-wrap items-center gap-2" data-testid="premiere-remind-form">
      <label htmlFor="premiere-remind-email" className="w-full text-xs font-bold text-white/80 inline-flex items-center gap-1.5"><BellRing className="w-3.5 h-3.5 text-[#FFD93D]" /> Remind me an hour before {pupName}'s premiere</label>
      <input id="premiere-remind-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com" className="flex-1 min-w-[180px] rounded-full bg-white/10 border-2 border-white/20 px-4 py-2 text-sm text-white placeholder:text-white/40 outline-none focus:border-[#FFD93D]" data-testid="premiere-remind-email" />
      <button type="submit" disabled={busy} className="rounded-full bg-[#FFD93D] text-[#19324A] font-display font-bold px-4 py-2 text-sm disabled:opacity-60" data-testid="premiere-remind-submit">{busy ? "Saving…" : "Remind me"}</button>
      <p className="w-full text-[11px] text-white/50">One email per premiere, Brisbane time. Unsubscribe link included.</p>
    </form>
  );
}
